import { Platform } from 'react-native';

// Liquid Glass (and the SwiftUI NativeTabs it requires) ships starting iOS 26. Android keeps
// the classic custom tab bar.
const MIN_NATIVE_TAB_BAR_IOS_VERSION = 26;

/** Pure platform check used by the hook and unit tests. */
export const isNativeTabBarPlatform = (
  platformOS: typeof Platform.OS,
  platformVersion: typeof Platform.Version
): boolean =>
  // Platform.Version can include a patch component (e.g. '26.0.1'), for which
  // Number(...) is NaN - parseInt to read just the major version, same as
  // src/utils/image/index.ts does for its own iOS version checks.
  platformOS === 'ios' && parseInt(String(platformVersion), 10) >= MIN_NATIVE_TAB_BAR_IOS_VERSION;

export const useIsNativeTabBarEnabled = (): boolean =>
  isNativeTabBarPlatform(Platform.OS, Platform.Version);
